import { useState } from "react";
import styles from "./wishlist.module.css";
import WishListCard from "./WishListCard/WishListCard";
import {
  Loader,
  Pagination,
  SubHeadingTitle,
} from "../../../../components/shared/index";
import {
  useGetWishLists,
  useRemoveWishList,
} from "../../../../queries/useWishListQuery";
import { getImageUrl } from "../../../../lib/get-image";
import { useAddToCart } from "../../../../queries/useCartQuery";
import toast from "react-hot-toast";

const WishList = () => {
  const { data: wishListItems, isPending, error } = useGetWishLists();
  const { mutate: addToCart, isPending: isCartPending } = useAddToCart();
  const [loadingItemId, setLoadingItemId] = useState(null);
  const { mutate: removeWish } = useRemoveWishList();
  const [currentPage, setCurrentPage] = useState(1);
  const per_page = 5;

  if (isPending) {
    return <Loader title="Loading wishlist..." />;
  }

  if (error) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
        <p>Failed to load wishlist.</p>
        <p>{error?.message || "Something went wrong"}</p>
      </div>
    );
  }

const formattedWishList = wishListItems
  ?.filter((item) => item?.product?.qty > 0) 
  ?.map((item) => {
    const originalPrice = Number(item.product?.price);
    const offerPrice = Number(item?.product?.offer_price);
    const hasOffer = offerPrice > 0;

    return {
      id: item?.id,
      productId: item?.product?.id,
      productQuantity: item?.product?.qty,
      productSlug: item?.product?.slug,
      image: getImageUrl(item.product?.thumb_image),
      title: item?.product?.name,
      size: item?.product?.qty || "N/A",
      sku: item?.product?.sku,
      price: hasOffer ? offerPrice : originalPrice,
      oldPrice: hasOffer ? originalPrice : null,
      offer: hasOffer
        ? Math.round(((originalPrice - offerPrice) / originalPrice) * 100)
        : 0,
    };
  });

const handleAddToCart = (item) => {
  if (!item.productId) {
    toast.error("Product ID missing");
    return;
  }

  setLoadingItemId(item.id);

  addToCart(
    {
      product_id: item?.productId,
      quantity: 1,
    },
    {
      onSuccess: () => {
        toast.success("Item added to cart");
      },
      onError: () => {
        toast.error("Failed to add item to cart");
      },
      onSettled: () => {
        setLoadingItemId(null);
      },
    }
  );
};

  const indexOfLast = currentPage * per_page;
  const indexOfFirst = indexOfLast - per_page;

  const currentItems = formattedWishList?.slice(indexOfFirst, indexOfLast);

  return (
    <div className={styles.wrapper}>
      <div className={styles.listWrapper}>
        {formattedWishList.length === 0 ? (
          <SubHeadingTitle
            style={styles.wishtext}
            subTitle={"No items in wishlist."}
          />
        ) : (
          currentItems.map((item) => (
            <WishListCard
              key={item.id}  
              item={item}
              isCartPending={loadingItemId === item.id}
              onAddToCart={() => handleAddToCart(item)}
              onRemove={() => removeWish(item?.id)}
            />
          ))
        )}
      </div>

      {formattedWishList.length > per_page && (
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            total={wishListItems?.length}
            per_page={per_page}
            handlePageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default WishList;